import api from "./api";
import { generateErrorMessage } from "../utils/message";


/*Email Recipients*/
export const registerEmailRecipient = async (emailRecipientData) => {
  try {
    const response = await api.post("/email-recipients", emailRecipientData);
    return response.data;
  } catch (error) {
    const fallback = generateErrorMessage("register", "email recipient");
    const msg = error.response?.data?.message || fallback;
    throw new Error(msg);
  }
};

export const fetchEmailRecipientsFromAPI = async (page = 1, perPage = 10, search = "", columnFilters = {}, sort = {}) => {
  try {
    const params = {
      page,
      per_page: perPage,
    };

    if (search) {
      params.search = search;
    }

    // Column-specific filters
    if (columnFilters.recipient_name) params.recipient_name = columnFilters.recipient_name;
    if (columnFilters.email_address) params.email_address = columnFilters.email_address;
    if (columnFilters.is_active) params.is_active = columnFilters.is_active;

    if (sort && sort.sortBy) {
      params.sort_by = sort.sortBy;
      params.sort_dir = sort.sortDir === 'desc' ? 'desc' : 'asc';
    }

    const response = await api.get("/email-recipients", { params });
    return response.data;
  } catch (error) {
    const fallback = generateErrorMessage("get data", "email recipient");
    const msg = error.response?.data?.message || fallback;
    throw new Error(msg);
  }
};

/* Fetch every recipient matching the filters, walking server pages (for Export). */
export const fetchAllEmailRecipientsForExport = async ({ search = "", columnFilters = {}, sort = {} } = {}, onProgress) => {
  const PER_PAGE = 1000;
  const collected = [];
  let page = 1;
  let total = 0;
  for (;;) {
    const response = await fetchEmailRecipientsFromAPI(page, PER_PAGE, search, columnFilters, sort);
    const payload = response?.data || {};
    const rows = Array.isArray(payload.emailRecipients) ? payload.emailRecipients : [];
    collected.push(...rows);
    total = Number(payload.pagination?.total) || collected.length;
    if (onProgress) onProgress(collected.length, total);
    const lastPage = Number(payload.pagination?.last_page) || 1;
    if (rows.length === 0 || page >= lastPage || collected.length >= total) break;
    page += 1;
  }
  return collected;
};

export const deleteEmailRecipientsFromAPI = async (emailRecipientId) => {
  try {
    const response = await api.delete(`/email-recipients/${emailRecipientId}`, {
      params: { id: emailRecipientId },
    });
    return response.data;
  } catch (error) {
    const fallback = generateErrorMessage("delete data", "email recipient");
    const msg = error.response?.data?.message || fallback;
    throw new Error(msg);
  }
};


export const fetchEmailRecipientById = async (emailRecipientId) => {
  try {
    const response = await api.get(`/email-recipients/${emailRecipientId}`);
    return response.data;
  } catch (error) {
    const fallback = generateErrorMessage("get data email recipient", "email recipient");
    const msg = error.response?.data?.message || fallback;
    throw new Error(msg);
  }
};

export const updateEmailRecipient = async (id, emailRecipientData) => {
  try {
    const response = await api.put(`/email-recipients/${id}`, emailRecipientData);
    return response.data;
  } catch (error) {
    const fallback = generateErrorMessage("update", "email recipient");
    const msg = error.response?.data?.message || fallback;
    throw new Error(msg);
  }
};

export const getActiveRecipientsFromAPI = async () => {
  try {
    const response = await api.get("/email-recipients/active");
    return response.data;
  } catch (error) {
    const fallback = generateErrorMessage("get data", "active recipients");
    const msg = error.response?.data?.message || fallback;
    throw new Error(msg);
  }
};

export const getRecipientsByTypeFromAPI = async (type) => {
  try {
    const response = await api.get(`/email-recipients/type/${type}`);
    return response.data;
  } catch (error) {
    const fallback = generateErrorMessage("get data", "recipients by type");
    const msg = error.response?.data?.message || fallback;
    throw new Error(msg);
  }
};

export const getRecipientsByDepartmentFromAPI = async (department) => {
  try {
    const response = await api.get(`/email-recipients/department/${department}`);
    return response.data;
  } catch (error) {
    const fallback = generateErrorMessage("get data", "recipients by department");
    const msg = error.response?.data?.message || fallback;
    throw new Error(msg);
  }
};

export const uploadEmailRecipientsFile = async (file, onUploadProgress) => {
  try {
    const formData = new FormData();
    formData.append("file", file);

    const response = await api.post("/email-recipients/submit-excel", formData, {
      headers: {
        "Content-Type": "multipart/form-data",
      },
      // Reports how much of the FILE has reached the server (0-100). Server-side
      // row inserting happens after this hits 100 and is not tracked here.
      onUploadProgress: onUploadProgress
        ? (event) => {
            if (event.total) {
              onUploadProgress(Math.round((event.loaded / event.total) * 100));
            }
          }
        : undefined,
    });
    return response.data;
  } catch (error) {
    const fallback = generateErrorMessage("upload", "email recipients file");
    const msg = error.response?.data?.message || fallback;
    throw new Error(msg);
  }
};
